/*! currentSection.js | v2.1.0 | license Copyright (C) 2020 - 2024 Taichi Matsutaka */
/*
 *
 * @name    : currentSection.js
 * @content : currentSection
 * @url     : https://github.com/taichaaan/js-currentSection
 * @creation: 2020.04.11
 * @update  : 2024.02.11
 * @version : 2.1.0
 *
 */
(function(global) {[]
	global.currentSection = function(target,options){
		const _this = this;

		/**************************************************************
		 * defaults options
		************************************************************ */
		this.target = Array.prototype.slice.call( document.querySelectorAll( target ) ,0) ;

		const defaults = {
			mediaQuery           : null,
			scrollElement        : 'body',
			currentClass         : 'is-current',
			sectionSelector      : '.js-section',
			navigationSelector   : '.js-navigation a',
			centerMode           : false,
			getSectionOffsetEvent: ['load','resize'],

			onChange    : null,
			onScrollStop: null,
		}


		/**************************************************************
		 * options
		************************************************************ */
		for( let option in options){
			defaults[option] = options[option];
		}
		this.options = defaults;


		/**************************************************************
		 * property
		************************************************************ */
		this.onStructures   = [];
		this.onRestructures = [];
		this.onDestroys     = [];
		this.startingFLg    = false;

		this.sections    = [];
		this.navigations = [];
		this.offsets     = [];

		this.currentPositions = [];
		this.prevPositions    = [];


		/**************************************************************
		 * method
		**************************************************************/
		this.initWindowDocument();
		this.getSize();
		this.settings();
		this.setupGetOffset();
		this.setupCheckCurrent();
		this.setupScrollStop();
		this.starting();

	};
	currentSection.prototype = {
		initWindowDocument: function(){
			const _this = this;

			/**************************************************************
			 * initWindowDocument
			**************************************************************/
			if( _this.options['scrollElement'] === 'body' ){
				_this.window   = window;
				_this.document = document.documentElement;
			} else{
				_this.window   = document.querySelector(_this.options['scrollElement']);
				_this.document = _this.window;
			}
		},
		getSize: function(){
			const _this = this;

			/**************************************************************
			 * window size
			**************************************************************/
			const getWindowSize = function(){
				_this.whHalf = _this.document.clientHeight / 2;
			}

			const getScrollTop = function(){
				_this.sy = _this.document.scrollTop;
			}

			this.onStructures.push( function(){
				window.addEventListener('DOMContentLoaded',getWindowSize);
				window.addEventListener('resize',getWindowSize);
				window.addEventListener('load',getScrollTop);
				_this.window.addEventListener('scroll',getScrollTop);
			});
			this.onRestructures.push( function(){
				getWindowSize();
				getScrollTop();
				window.addEventListener('resize',getWindowSize);
				_this.window.addEventListener('scroll',getScrollTop);
			});
			this.onDestroys.push( function(){
				window.removeEventListener('DOMContentLoaded',getWindowSize);
				window.removeEventListener('resize',getWindowSize);
				window.removeEventListener('load',getScrollTop);
				_this.window.removeEventListener('scroll',getScrollTop);
			});
		},
		settings: function(){
			const _this = this;

			/**************************************************************
			 * addSettings
			**************************************************************/
			const addSettings = function(){
				for (let i = 0; i < _this.target.length; i++) {
					_this.sections[i]    = _this.target[i].querySelectorAll( _this.options['sectionSelector'] );
					_this.navigations[i] = _this.target[i].querySelectorAll( _this.options['navigationSelector'] );
				}

				for ( let i = 0; i < _this.sections.length; i++ ) {
					_this.offsets[i]          = [];
					_this.currentPositions[i] = 0;
					_this.prevPositions[i]    = null;
				}
			}

			this.onStructures.push( function(){
				addSettings();
			});
			this.onRestructures.push( function(){
				addSettings();
			});



			/**************************************************************
			 * removeSettings
			**************************************************************/
			const removeSettings = function(){
				_this.sections    = [];
				_this.navigations = [];
				_this.offsets     = [];

				_this.currentPositions = [];
				_this.prevPositions    = [];
			}

			this.onDestroys.push( function(){
				removeSettings();
			});

		},
		setupGetOffset: function(){
			const _this = this;

			/**************************************************************
			 * setupGetOffset
			 * getOffset関数のセットアップ
			**************************************************************/
			let getSectionOffset = function(){};

			if( _this.options['centerMode'] == true ){
				getSectionOffset = function(){
					for ( let i = 0; i < _this.sections.length; i++ ) {
						for ( let j = 0; j < _this.sections[i].length; j++ ) {
							const offset = _this.sections[i][j].getBoundingClientRect().top + _this.sy - 1;
							_this.offsets[i][j] = offset - _this.whHalf;
						}
					}
				}
			} else{
				getSectionOffset = function(){
					for ( let i = 0; i < _this.sections.length; i++ ) {
						for ( let j = 0; j < _this.sections[i].length; j++ ) {
							const offset = _this.sections[i][j].getBoundingClientRect().top + _this.sy - 1;
							_this.offsets[i][j] = offset;
						}
					}
				}
			}

			this.onStructures.push( function(){
				for ( let i = 0; i < _this.options['getSectionOffsetEvent'].length; i++ ) {
					window.addEventListener( _this.options['getSectionOffsetEvent'][i] ,getSectionOffset);
				}
			});
			this.onRestructures.push( function(){
				for ( let i = 0; i < _this.options['getSectionOffsetEvent'].length; i++ ) {
					window.addEventListener( _this.options['getSectionOffsetEvent'][i] ,getSectionOffset);
				}
			});
			this.onDestroys.push( function(){
				for ( let i = 0; i < _this.options['getSectionOffsetEvent'].length; i++ ) {
					window.removeEventListener( _this.options['getSectionOffsetEvent'][i] ,getSectionOffset);
				}
			});

		},
		setupCheckCurrent: function(){
			const _this = this;

			/**************************************************************
			 * setupCheckCurrent
			 * checkCurrent関数のセットアップ
			**************************************************************/
			const setCurrent = function(){
				for ( let i = 0; i < _this.sections.length; i++ ) {

					if( _this.offsets[i].length ){
						if( _this.sy < _this.offsets[i][0] ){
							_this.navigations[i][0].classList.add( _this.options['currentClass'] );
							_this.currentPositions[i] = -1;
						} else{
							for ( let j = 0; j < _this.offsets[i].length; j++ ) {
								if( _this.sy > _this.offsets[i][j] ){
									_this.currentPositions[i] = j;
								}
							}

							if( _this.navigations[i][ _this.prevPositions[i] ] ){
								_this.navigations[i][ _this.prevPositions[i] ].classList.remove( _this.options['currentClass'] );
							}
							if( _this.navigations[i][ _this.currentPositions[i] ] ){
								_this.navigations[i][ _this.currentPositions[i] ].classList.add( _this.options['currentClass'] );
							}

							if( _this.currentPositions[i] !== _this.prevPositions[i] ){
								if( typeof _this.options['onChange'] === 'function' ){
									_this.options['onChange']( _this.target[i] , _this.currentPositions[i] , _this.prevPositions[i] );
								}
							}

							_this.prevPositions[i] = _this.currentPositions[i];
						}
					}

				}
			}


			this.onStructures.push( function(){
				window.addEventListener('load',setCurrent);
				_this.window.addEventListener('scroll',setCurrent);
			});
			this.onRestructures.push( function(){
				window.addEventListener('load',setCurrent);
				_this.window.addEventListener('scroll',setCurrent);
			});
			this.onDestroys.push( function(){
				window.removeEventListener('load',setCurrent);
				_this.window.removeEventListener('scroll',setCurrent);
			});

		},
		setupScrollStop: function(){
			const _this = this;

			/**************************************************************
			 * setupScrollStop
			 * scrollStop関数のセットアップ
			**************************************************************/
			let timeoutId = null;

			const scrollStop = function(){
				clearTimeout( timeoutId ) ;

				timeoutId = setTimeout(function(){
					for ( let i = 0; i < _this.sections.length; i++ ) {
						if( typeof _this.options['onScrollStop'] === 'function' ){
							_this.options['onScrollStop']( _this.target[i] , _this.currentPositions[i] , _this.prevPositions[i] );
						}
					}
				},100);
			}

			this.onStructures.push( function(){
				_this.window.addEventListener('scroll',scrollStop);
			});
			this.onRestructures.push( function(){
				_this.window.addEventListener('scroll',scrollStop);
			});
			this.onDestroys.push( function(){
				_this.window.removeEventListener('scroll',scrollStop);
			});

		},
		starting: function(){
			const _this = this;

			/**************************************************************
			 * starting
			 * ブレイクポイントに合わせて発動
			**************************************************************/
			if( _this.options['mediaQuery'] == null ){
				_this.onStructure();
			} else{
				const breakPoint = function(){
					const mediaQuery = window.matchMedia( _this.options['mediaQuery'] );

					function checkBreakPoint( mediaQuery ) {
						if ( mediaQuery.matches ) {
							if( _this.startingFLg == false ){
								_this.onStructure();
							} else{
								_this.onRestructure();
							}
						} else{
							_this.onDestroy();
						}
					}

					mediaQuery.addListener( checkBreakPoint ); // ブレイクポイントの度に
					checkBreakPoint( mediaQuery ); // 初回
				}
				breakPoint();
			}

			_this.startingFLg = true;
		},
		onStructure: function(){
			/**************************************************************
			 * 構築メソッド
			************************************************************ */
			const onStructures = this.onStructures;
			for ( let i = 0; i < onStructures.length; i++ ) {
				onStructures[i]();
			}
		},
		onRestructure: function(){
			/**************************************************************
			 * 再構築メソッド
			************************************************************ */
			const onRestructures = this.onRestructures;
			for ( let i = 0; i < onRestructures.length; i++ ) {
				onRestructures[i]();
			}
		},
		onDestroy: function(){
			/**************************************************************
			 * 破壊メソッド
			************************************************************ */
			const onDestroys = this.onDestroys;
			for ( let i = 0; i < onDestroys.length; i++ ) {
				onDestroys[i]();
			}
		},
	};

})(this);
